import { pairedDevicesActivateRequestAction as activate } from './activate';
import { pairedDevicesFetchAllRequestAction as fetchAll } from './fetchAll';
import { pairedDevicesPropertiesSelector as propertiesSelector } from '../selectors/properties';

const listLength = (state) => propertiesSelector(state).list.length;

export const pairedDevicesActivateAndFetchThunkAction = (activateParams) => async (
  dispatch,
  getState,
) => {
  const devicesLength = listLength(getState());
  const res = await dispatch(activate(activateParams));

  if (res.payload.success) {
    while (devicesLength === listLength(getState())) {
      await dispatch(fetchAll()); // eslint-disable-line no-await-in-loop
    }
  }

  return res;
};
